import type { Board } from '../game/Board';

/** Small contextual scene caption; DOM writes happen only on interaction changes. */
export class Feedback {
  private readonly el = document.createElement('div');
  private readonly title = document.createElement('div');
  private readonly detail = document.createElement('div');
  private version = -1;

  constructor(host: HTMLElement, private readonly board: Board) {
    this.el.className = 'scene-feedback';
    this.el.setAttribute('role', 'status');
    this.el.setAttribute('aria-live', 'polite');
    this.title.className = 'scene-feedback-title';
    this.detail.className = 'scene-feedback-detail';
    this.el.append(this.title, this.detail);
    host.appendChild(this.el);
    this.update();
  }

  update() {
    const f = this.board.feedback;
    if (f.version === this.version) return;
    this.version = f.version;
    this.title.textContent = f.title;
    this.detail.textContent = f.detail;
    this.el.dataset.tone = f.tone;
    this.el.style.setProperty('--accent', `#${f.color.toString(16).padStart(6, '0')}`);
  }
}
